import { Constants } from "./../constants";
import { GenericScreenController } from "./generic-screen-controller";
import { IScreenStatusCommand } from "./../screen-status-command";
import { NavigationBarManager } from "../navigation-bar-manager";

/**
 * Controller for screens with radiobutton questions. 
 * This class contians all the generic logic related to this kind of screens
 */
export class RadiobuttonScreenController extends GenericScreenController {

    constructor(screenIndex: number, navigationBarManager: NavigationBarManager) {
        super(screenIndex, navigationBarManager);
    }

    public initEvents() {
        this.screenDomElement.find(`.FormChoice__Input.FormChoice__Input--Radio`).click(this.onRadioButtonClick.bind(this));
    }

    public loadScreenInitialStatus(): void {
        let selectedOption = this.screenDomElement.find(`.FormChoice__Input.FormChoice__Input--Radio:checked`).val();
        if (selectedOption) {
            this.enableNextButton();
        } else {
            this.disableNextButton();
        }
    }

    public validateScreen(): boolean {
        return this.validateRequiredRadiobuttonQuestion(0);
    }

    public showScreen(): void {
        let self = this;
        this.screenDomElement.show();
        this.recordAnalyticsPageViewEvent();
    }

    public onRadioButtonClick(e) {
        this.enableNextButton();
    }

}